import { broadcastAllSites } from 'serviceWorker/broadcasts/sites';
import { Services } from 'shared/domain/messages/message';
import * as sites from 'serviceWorker/db/sites/sites';
import * as sitesService from 'serviceWorker/db/sites/sitesService';
import { fetchSites, fetchUpdatedSites } from './fetchSites';

import type {
  CreateSiteRequest,
  EditSiteRequest,
  SiteDeleteRequest,
  SiteRestoreRequest,
} from 'shared/domain/messages/site/eventMessages';
import { debugLog } from 'shared/logger/debugLog';
import { siteSaver } from './addSite';
import { siteDeleter } from './deleteSite';
import { siteEditor } from './editSite';
import { siteRestorer } from './restoreSite';

import { siteContract } from 'shared/domain/site/siteContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/** Download and sync of the sites; `siteSource.sync` is its entry point. */
export const sitesSync = createSyncedEntity({
  entityName: Services.SITES,
  contract: siteContract,
  repository: sites,
  service: sitesService,
  fetch: fetchSites,
  fetchUpdated: fetchUpdatedSites,
  publishCollection: broadcastAllSites,
});

/**
 * Resolves once the change is in the HTTP queue and rejects only when it could
 * not be queued. The server's answer follows as an event (`uploadedEntity`,
 * `failUploadedEntity`, …) with the change's `uniqueId`.
 */
export function handleAddSite(detail: CreateSiteRequest): Promise<void> {
  debugLog('addSite', detail);
  return siteSaver.execute(detail.siteCreateModel, detail.uniqueId);
}

export function handleEditSite(detail: EditSiteRequest): Promise<void> {
  debugLog('editSite', detail);
  return siteEditor.execute(detail.siteEditModel, detail.uniqueId);
}

export function handleDeleteSite(detail: SiteDeleteRequest): Promise<void> {
  debugLog('deleteSite', detail);
  return siteDeleter.execute(detail);
}

export function handleRestoreSite(detail: SiteRestoreRequest): Promise<void> {
  debugLog('restoreSite', detail);
  return siteRestorer.execute(detail);
}
